import { FC } from "react";
import styled from "styled-components";
import { Response } from "../types";
import { observer } from "mobx-react";

const P = styled.p`
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
`;

const ErrorP = styled(P)`
  color: #e24747;
`;
const SuccessP = styled(P)`
  color: #1e8a1e;
`;

const Result: FC<Response> = observer(({ message, status }) => {
  if (status === "error") {
    return <ErrorP>{message}</ErrorP>;
  }

  if(status === "success") {
    return <SuccessP>{message}</SuccessP>
  }

  return <P>{message}</P>;
});

export default Result;
